import "core-js/fn/array/find"
import "core-js/fn/array/find-index"
import "core-js/fn/array/from"
import "core-js/fn/map"
import "core-js/fn/object/assign"
import "core-js/fn/promise"
import "core-js/fn/set"
import "element-closest"
import "mutation-observer-inner-html-shim"



//////////////////
// WEBPACK FOOTER
// ./node_modules/@stimulus/polyfills/index.js
// module id = ./node_modules/@stimulus/polyfills/index.js
// module chunks = vendor